import React from 'react';
import PropTypes from 'prop-types';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import { createdFromNow } from '../../../helpers/dateTime';
import { ConvertLinksToHyperLinks } from '../../../helpers/strings';
import TextArea from '../../Common/TextArea';
import { MAX_SUPPORT_TICKET_CHAR_LENGTH, DATE_FORMAT } from '../../../constants/constants';
import Moment from 'moment';
import './AgentTicketDrawer.scss';
import Icon from '../../Common/Icon';

export default class AgentTicketForm extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            showAttachFileDropdown: false
        }
    }

    onAgentChange = (value, name) => {
        const newAgentId = (!value) ? "" : value;
        this.props.onFormChange(name, newAgentId);
    }
    onTextChange = (e) => {
        this.props.onFormChange(e.target.name, e.target.value);
    }

    onMakeInternalResponse = () => {
        this.props.onFormChange("isInternal", !this.props.ticket.isInternal);
    }

    onShowAttachFile = () => {
        this.setState({ showAttachFileDropdown: true });
    }

    onSelectFile = (id, name) => {
        this.props.onFormChange(name, id);
    }

    onViewAttachment = (customerFileName) => {
        this.props.fileActions.download(customerFileName);
    }

    render() {

        const internalResponseText = (this.props.ticket.isInternal) ? "Respond to User" : "Respond Internally";
        const textAreaLabel = (this.props.ticket.isInternal) ? "Internal Response" : "Response";
                
        return (
            <div className="support-conversation">
                { this.props.ticket.createdByUserId > 1 &&
                    <div className="support-response-toggle">
                        <button name="makeInternal" type="button" className="btn btn-link" onClick={this.onMakeInternalResponse}>{internalResponseText}</button>
                    </div>
                }
                <div className="title"><label><strong>Ticket #:</strong></label> {this.props.ticket.id}</div>
                <label><strong>Opened By:</strong></label> {this.props.ticket.createdByName} ({this.props.ticket.createdByUserName})<br />
                <label><strong>Opened On:</strong></label> {Moment(this.props.ticket.createdDate).format(DATE_FORMAT)} ({createdFromNow(this.props.ticket.createdDate)})<br />
                <label><strong>Location:</strong></label> 
                {this.props.ticket.locationName ? (
                <span>
                    {this.props.ticket.locationName} ({this.props.ticket.locationAbbrev})
                </span>
                ) : (
                <span>No location found</span>
                )}
                <br />
                <label><strong>Subject:</strong></label> {this.props.ticket.subject}<br /><br />
                
                <form noValidate className={this.props.isFormValid ? "" : "was-validated"}>
                    <MultiSelectBox name="agentId" label="Agent" placeholder="Agent" idField="id" valueField="name" options={this.props.agents} selectedValues={this.props.ticket.agentId.toString()} onChange={this.onAgentChange} isMulti={false} isRequired={true} />
                    <TextArea name="response" label={textAreaLabel} rows={5} placeholder={textAreaLabel} onChange={this.onTextChange} maxLength={1000} isRequired={true} errorMessage="A Response is required" />                
                </form>
                <div className="remaining-chars text-end mb-2">{this.props.ticket.response.length}/{MAX_SUPPORT_TICKET_CHAR_LENGTH}</div>

                {this.state.showAttachFileDropdown ?
                    <div className="attach-file-section">
                        <MultiSelectBox name="customerFileId" label="Baseline File" idField="id" valueField="name" placeholder="Choose a Baseline File" options={this.props.files} selectedValues={this.props.ticket.customerFileId.toString()} onChange={this.onSelectFile} isMulti={false} />
                    </div>
                :
                    <div className="attach-file-btn btn btn-link" onClick={this.onShowAttachFile}>Attach a Baseline File</div>                    
                }

                {this.props.ticket.messages && this.props.ticket.messages.length > 0 &&
                    <div className={(this.props.ticket.isResolved) ? "messages-wrapper resolved" : "message-wrapper"}>
                        {this.props.ticket.messages.map(msg =>
                            <div key={msg.id}>
                                {msg.customerFileName &&
                                    <span onClick={() => this.onViewAttachment(msg.customerFileName)}><Icon name="paperclip left" /></span>
                                }
                                <div className={this.props.ticket.agentId === msg.userId ? "message to" : "message from"}>{msg.message}</div>
                                <div className="datetime">
                                    {this.props.userId == msg.userId ? "You @ " : msg.userName + " @ "}
                                    {Moment(msg.createdDate).format(DATE_FORMAT + " h:mm A")}
                                </div>
                            </div>
                        )}

                    </div>
                }
                <div className="message-wrapper">
                    <div className="message from first">{ConvertLinksToHyperLinks(this.props.ticket.description)}</div>
                </div>
            </div>
        );
    }

}

AgentTicketForm.propTypes = {
    fileActions: PropTypes.object.isRequired,
    ticket: PropTypes.object.isRequired,
    agents: PropTypes.array.isRequired,
    files: PropTypes.array.isRequired,
    onFormChange: PropTypes.func.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    userId: PropTypes.number.isRequired
}
